export const STATE_PROP = 'machineVncSession';
export const VNC_SESSION_STATUS = {
  RUNNING: 'RUNNING',
  WAITING: 'WAITING',
  FAILED: 'FAILED'
};
